export default __webpack_public_path__ + "static/media/icon-add-user.2a37e455.svg";